import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'login',
  `
    UPDATE_LOGIN_FORM
    RESET_LOGIN_FORM

    SUBMIT_LOGIN
    SUBMIT_LOGIN_DONE
    SUBMIT_LOGIN_FAIL

    RESET_RESULT

    SESSION_TIMED_OUT
    RESET_SESSION_TIMED_OUT

    GOOGLE_ONETAP_SIGNUP
    
    REAUTHENTICATE
  `
);
